<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-if="!isLoading" id="app">
      <Navbar />
      <router-view />
      <Footer />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Loading from "./views/Loading";

export default {
  name: "home",
  components: {
    Navbar,
    Footer,
    Loading,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  created() {
    // this.initialize();
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  },
  methods: {
    // initialize() {
    //   axios
    //     .get('https://api.ardunic.com/v1/cart', {
    //       headers: { access_token: localStorage.getItem('token') },
    //     })
    //     .then((response) => {
    //       if (response.success) {
    //         return 0;
    //       }
    //     })
    //     .catch(() => {
    //       this.$store.dispatch('destroyToken').then(() => {
    //         this.$router.push({ name: '' });
    //       });
    //     });
    // },
  },
};
</script>

<style>
@font-face {
  font-family: myfont;
  src: url(/assets/fonts/25996.ttf) format("truetype");
}

html,
body {
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  font-family: myfont, sans-serif;
  outline: none;
}

button:focus {
  outline: none !important;
}

body {
  font-size: 60px;
}

.dicountspan {
  position: absolute;
  z-index: 9999;
  background: linear-gradient(to right, #ff3fbb, #ff8891);
  border-radius: 15px;
  width: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  color: white;
  padding: 4px;
}

.ardunictn {
  width: 100px;
  text-align: center;
  padding: 5px 10px 5px 10px;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
}

.red {
  background: linear-gradient(right, #ff3fbb, #ff8891);
}

.animatee {
  transition: transform 0.5s;
}

.animatee::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
  content: "";
  opacity: 0;
  z-index: -1;
}
.animatee:hover {
  /*   transform: scale3d(1.006, 1.006, 1); */
  transform: translateY(-10px);
}
.animatee:hover::after {
  opacity: 1;
}

.zoomIn:hover {
  transform: scale(1.5);
  overflow: hidden;
}

.zoomIn {
  transition: all 1.5s ease;
}

.zoomIn:hover {
  transform: scale(1.5);
}

.card-img-new,
.brands-classes,
.img-new,
.image-conatainer {
  overflow: hidden !important;
}
</style>
